import { baseApi } from "@/redux/api/baseApi";

const paymentMethodApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPaymentMethod: builder.query({
      query: (creatorId) => ({
        url: `/creator-payment-method/get?creatorId=${creatorId}`,
        method: "GET",
      }),
      providesTags: ["PaymentMethods"],
    }),
    addPaymentMethod: builder.mutation({
      query: (payload) => ({
        url: "/creator-payment-method/create",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["PaymentMethods"],
    }),
    updatePaymentMethod: builder.mutation({
      query: ({ id, ...payload }) => ({
        url: `/creator-payment-method/update/${id}`,
        method: "PATCH",
        body: payload,
      }),
      invalidatesTags: ["PaymentMethods"],
    }),
    deletePaymentMethod: builder.mutation({
      query: (id) => ({
        url: `/creator-payment-method/delete/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["PaymentMethods"],
    }),
  }),
});

export const { 
  useGetPaymentMethodQuery, 
  useAddPaymentMethodMutation, 
  useUpdatePaymentMethodMutation,
  useDeletePaymentMethodMutation
} = paymentMethodApi;